import React, { useContext, useEffect } from 'react';
import styles from './CookieBlocker.module.scss';
import classNames from 'classnames';
import { setCookie } from '../../utils/cookie';
import Button from '../Button';
import PropTypes from 'prop-types';
import { GlobalPropsContext } from '../../utils/globalProps';

const CookieBlocker = ({ type, url, provider }) => {
    const globalProps = useContext(GlobalPropsContext);
    const { activateCookieScript } = globalProps;
    let cookieType;
    let what;

    if (type === 'Video') {
        cookieType = provider;
        what = 'videon';
    } else if (type === 'Iframe') {
        cookieType = 'Iframe';
        what = 'iframe';
    } else {
        cookieType = 'Google Maps';
        what = 'kartan';
    }

    useEffect(() => {
        if (typeof window !== 'undefined' && window?.CookieScript?.instance) {
            window.addEventListener('CookieScriptClose', () => {
                window.location.reload();
            });

            window.addEventListener('CookieScriptAccept', () => {
                window.location.reload();
            });

            window.addEventListener('CookieScriptAcceptAll', () => {
                window.location.reload();
            });

            window.addEventListener('CookieScriptReject', () => {
                window.location.reload();
            });
        }
    }, []);

    const onClick = () => {
        if (
            typeof window !== 'undefined' &&
            window?.CookieScript &&
            activateCookieScript
        ) {
            window.CookieScript.instance.show();
        } else {
            setCookie('hide_cookiebar', false);
            window?.location?.reload();
        }
    };

    const classes = classNames(styles['Content'], styles[`Content--${type}`]);
    return (
        <div className={styles['CookieBlocker']}>
            <div className={classes}>
                <p className={styles['Paragraph']}>
                    Du har inte valt att godkänna {cookieType}-kakor, och därför
                    kan vi inte visa {what} som ska vara här.
                </p>
                <p className={styles['Paragraph']}>
                    Öppna cookie-inställningarna med knappen nedan om du vill
                    justera dina val, eller öppna {what} i nytt fönster genom
                    att klicka på{' '}
                    <a href={url} target="_blank" rel="noopener noreferrer">
                        denna länk
                    </a>
                    .
                </p>

                <Button
                    type="Primary"
                    onClick={onClick}
                    text="Öppna cookie-inställningar"
                />
            </div>
        </div>
    );
};

CookieBlocker.propTypes = {
    type: PropTypes.string,
    url: PropTypes.string,
    provider: PropTypes.string,
};

CookieBlocker.defaultProps = {
    type: '',
    url: '',
    provider: '',
};

export default CookieBlocker;
